import React from 'react';

export function FinalBracket(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.5 20H10m0 0V0m0 20h9" stroke="#2B6A6B" strokeWidth={0.6} strokeLinecap="round" />
    </svg>
  );
}
